import useTranslation from "../../../shared/hooks/useTranslation";
import { UserRole } from "../models/userModels";

export const useRoleLabel = () => {
  const { translate } = useTranslation("common");
  return (role: UserRole) => translate(`roles.${role.name}`, { defaultValue: role.name });
}; 